/* eslint-disable @typescript-eslint/default-param-last */
import { GET_AI_INTERVIEWS_SUCCESS } from '../../constants/ActionTypes';
import {
  BULK_INVITE_CANDIDATES_SUCCESS,
  BULK_INVITE_STATUS_FINISH,
  BULK_INVITE_CANDIDATES_FAILED,
  BULK_INVITE_STATUS_FAILED,
  GET_TRY_TEST_LINK,
  GET_TRY_TEST_LINK_FINISHED,
} from '../../constants/ActionTypes';
import {
  IAiInterviewState,
  AiInterviewActionType,
} from '../../types/Interviews/aiInterview.types';
import initialState from '../../store/initialState';

/* eslint-disable @typescript-eslint/default-param-last */
const aiInterviewReducer = (
  state = initialState.aiInterview,
  action: AiInterviewActionType
): IAiInterviewState => {
  switch (action?.type) {
    case GET_AI_INTERVIEWS_SUCCESS:
      return {
        ...state,
        interviewList: action.payload.interviewList || [],
        meta: action.payload.meta || state.meta,
      };
    case BULK_INVITE_CANDIDATES_SUCCESS:
      return {
        ...state,
        bulkInviteInProgress: action.payload.bulkInviteInProgress,
        bulkTestSlug: action.payload.bulkTestSlug,
      };
    case BULK_INVITE_CANDIDATES_FAILED:
      return {
        ...state,
        bulkInviteInProgress: false,
        bulkTestSlug: null,
      };
    case BULK_INVITE_STATUS_FAILED:
      return {
        ...state,
        bulkInviteStatusPolling: false,
        bulkInviteStatusData: null,
        bulkInviteInProgress: false,
      };
    case BULK_INVITE_STATUS_FINISH:
      return {
        ...state,
        bulkTestSlug: null,
      };
    case GET_TRY_TEST_LINK:
      return {
        ...state,
        getTryTestInProgress: true,
      };
    case GET_TRY_TEST_LINK_FINISHED:
      return {
        ...state,
        getTryTestInProgress: false,
      };
    default:
      return state;
  }
};

export default aiInterviewReducer;
